// For Firebase JS SDK v7.20.0 and later, measurementId is optional
import firebase from 'firebase'

const firebaseConfig = {
  apiKey: "AIzaSyA047s7cDycEEbsUfi41V3cXidJw-L2ilE",
  authDomain: "challenge-c37d0.firebaseapp.com",
  databaseURL: "https://challenge-c37d0.firebaseio.com",
  projectId: "challenge-c37d0",
  storageBucket: "challenge-c37d0.appspot.com",
  messagingSenderId: "1091033853931",
  appId: "1:1091033853931:web:1daf4b13a8c49ff81a73ae",
  measurementId: "G-LEF2LL8TF0"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore()
const auth = firebase.auth();

export { db, auth };